import { environment } from '@environment';

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AppRoutes, FundService as CoreFundService } from '@gs-2.0/core';
import { ExpiredFundDialogService } from '@gs-2.0/shared';

export const expiredFundGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const coreFundService = inject(CoreFundService);
  const expiredFundDialogService = inject(ExpiredFundDialogService);

  // If fund data isn't loaded yet (e.g. PORTAL_USER bypasses portalAdminFundGuard),
  // load it now so the expiry check has data to work with.
  if (!coreFundService.selectedFund()) {
    await coreFundService.loadFunds();
  }

  const currentFund = coreFundService.selectedFund();

  if (!currentFund) {
    return true;
  }

  const charityStatus = currentFund.charityStatus;
  if (charityStatus && charityStatus.toLowerCase().includes('expired')) {
    expiredFundDialogService.open(currentFund.fundName, environment.fund?.mailTo);
    if (state.url.startsWith(AppRoutes.FUND_DASHBOARD)) {
      return true;
    }
    return false;
  }

  return true;
};
